import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import MobiusPage from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    let lrId;
    if (location && location.search) {
        const parsedQuery = parseQueryString<{ lrid: string }>(location.search);
        lrId = parsedQuery.lrid;
    }

    return {
        lrId,
        redirectToRewardsPageUrl: getPageLinkByPageType(state, "RedirectToRewardsGalleryPage")?.url,
    };
};

interface OwnProps extends PageProps {
    fields: {
        useNewDesign?: boolean;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const RewardsGalleryPage = ({ id, lrId, redirectToRewardsPageUrl, fields }: Props) => {
    const history = useHistory();
    const { isInShell } = useShellContext();
    useEffect(() => {
        if (isInShell) {
            return;
        }
        if (!fields.useNewDesign) {
            if ((!lrId || lrId === undefined) && (redirectToRewardsPageUrl || redirectToRewardsPageUrl !== undefined)) {
                history.push(`${redirectToRewardsPageUrl}`);
            }
        }
    }, [lrId, redirectToRewardsPageUrl, fields.useNewDesign]);

    return (
        <MobiusPage>
            <Zone contentId={id} zoneName="Content" requireRows />
            <Modals />
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, null)(RewardsGalleryPage),
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                name: "useNewDesign",
                displayName: "Use New Rewards Design",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 200,
                tooltip: "Toggle between new rewards design and existing lrid-based flow.",
            },
        ],
    },
};

export default pageModule;
